// extracted by mini-css-extract-plugin
module.exports = {"icon":"LandingGuiaRent_icon__2wsGG","backgroundVideo":"LandingGuiaRent_backgroundVideo__6D_s1","backgroundVideoInquilino":"LandingGuiaRent_backgroundVideoInquilino__Hlvzg"};